import type { MailboxInfo } from "owa-client-types";
import { isLicensingMailboxInfo } from "owa-account-source-list-types/lib/utils/isLicensingMailboxInfo";
import { getCoprincipalAccountForMailboxInfo } from "owa-account-source-list-store";

export default function getMailboxTypeForBizchatTelemetry(mailboxInfo: MailboxInfo): string | undefined {
    let mailboxInfoToUse = mailboxInfo;
    
    // In cloud cache linked account scenarios, Copilot interactions may be routed through
    // a licensing mailbox (EASID) that was linked to the cloud cache account via
    // owa-cloud-cache-link. The licensing mailbox rank == 'Licensing' and provider == "Outlook"
    // which don't reflect the actual mailbox provider (e.g. Google, IMAP).
    // We resolve back to the coprincipal account's mailbox to get the real provider and
    // type for accurate telemetry classification.
    if (isLicensingMailboxInfo(mailboxInfo)) {
        const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);
        if (account) {
            mailboxInfoToUse = account.mailboxInfo;
        }
    }
    
    if (mailboxInfoToUse.type === "SharedMailbox") {
        return "Shared";
    }
    
    switch (mailboxInfoToUse.mailboxProvider) {
        case "Office365":
        case "Outlook":
            return "1stParty";
        case "Google":
        case "Yahoo":
        case "ICloud":
        case "IMAP":
        case "POP3":
        case "PstFile":
        case "MessageFile":
            return "3rdParty";
        default:
            return undefined;
    }
}
